<script context='module'>
	/**
	 * @author M.G.
	 */
	import WhatsAppEditorPopup from './WhatsAppEditorPopup.svelte';
	import {External, M} from '../../../external';

	export function editWhatsApp(contact, message, onChange, showDate) {

		if (!contact.subscribed) {
			External.Tools.showError(M.CONTACT_NOT_SUBSCRIBED);
			return;
		}

		return new Promise((resolve) => {
			let component;
			External.Tools.showWindow({
				title: '',
				icon: External.Popup.ICON_EDIT,
				width: 650,
				//height: 320,
				addCloseButton: true,
				height: (window.innerHeight * 0.6) + 'px',
				customClass: 'contact-message-dialog',
				isModal: true,
				withDarkBackground: true,
				forceAtRight: false,
				action: {
					onShow: (popup, context) => {
						component = new WhatsAppEditorPopup({
							target: popup.getContentArea(),
							props: {
								popup: popup,
								contact: contact,
								message: message,
								onChange: onChange,
								showDate: showDate
							}
						});
						resolve(component);
					},
					onHide: () => {
						if (component) {
							component.$destroy();
							component = null;
						}
					}
				}
			});
		});
	}

</script>

<script>
	import WhatsAppEditor from './WhatsAppEditor.svelte';
	import {ignore} from '../../../Common/tools';

	export let popup, contact, message, onChange, showDate;

</script>

<div class='popup-widget-wrapper flex flex-col flex-1 height-100 overflow-auto dynamic-popup-content'
		 style='padding-top: 25px; padding-bottom: 0px;'>

	<WhatsAppEditor {popup} {contact} {message} {onChange} {showDate} enableScheduling={true} enablePolling={true}>
		<svelte:fragment slot='footerButtons' let:message let:isSendAllowed let:sendNow let:scheduleMessage let:sendScheduledNow let:isNewTemplate let:submitTemplate let:cancel>

			<div class='f-left contact-message-dialog-footer t-left flex-none'>
				{#if isNewTemplate}
					<a on:click={submitTemplate} class='middle-button f-none inline-block rounded-effect blue'>
						{M.SUBMIT_MESSAGE_FOR_APPROVAL}
					</a>
				{:else if message.id || (message.sendTime && message.sendTime.getTime() > new Date().getTime())}
					<!--existing scheduled message or selected date is in the future-->
					<a on:click={isSendAllowed ? scheduleMessage : ignore} class='middle-button f-none inline-block rounded-effect blue' class:disabled={!isSendAllowed}>
						{M.SAVE_MESSAGE}
					</a>
				{:else}
					<a on:click={isSendAllowed ? sendNow : ignore} class='middle-button f-none inline-block rounded-effect blue' class:disabled={!isSendAllowed}>
						{M.SEND_MESSAGE}
					</a>
				{/if}
				{#if message.id}
					<a on:click={isSendAllowed ? sendScheduledNow : ignore} class='middle-button f-none inline-block rounded-effect gray' class:disabled={!message.templateApproved}>{M.SEND_NOW}</a>
				{/if}
				<a on:click={cancel} class='middle-button f-none inline-block rounded-effect gray ml-5'>{M.CANCEL}</a>
			</div>

		</svelte:fragment>
	</WhatsAppEditor>

</div>
